// Shared leaderboard visibility rules

import { isAppDevEnvironment } from "../utils/appEnv";

export const LEADERBOARD_EXCLUDE_PATHS: string[] = [
	"/contact-us",
	"/profile",
	"/leaderboard",
	"/dashboard/timeline",
	"/survey/ace-society-championship",
	"/for-courses",
	...(isAppDevEnvironment() ? ["/dev/"] : []),
];

export function isExcludedPath(pathname: string): boolean {
	return LEADERBOARD_EXCLUDE_PATHS.some((excludePath) =>
		excludePath === "/" ? pathname === "/" : pathname.startsWith(excludePath)
	);
}


